import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { RootState } from '../../../../infrastructure/redux/store';
import { CadastroPage } from '../pages/cadastro.page';
import { LoginPage } from '../pages/login.page';
import { LogoutPage } from '../pages/logout.page';
import { OAuthPage } from '../pages/oauth.page';

const AutenticacaoRoutes: React.FC = () => {
  const { autenticado } = useSelector((state: RootState) => state.autenticacao);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!autenticado && location.pathname !== '/oauth2/callback') navigate('/autenticacao/login');

    () => {
      navigate('/');
    };
  }, [autenticado]);

  return (
    <Routes>
      <Route path='/autenticacao'>
        <Route path='login' element={<LoginPage />} />
        <Route path='logout' element={<LogoutPage />} />
        <Route path='cadastro' element={<CadastroPage />} />
      </Route>
      <Route path='/oauth2'>
        <Route path='callback' element={<OAuthPage />} />
      </Route>
    </Routes>
  );
};

export { AutenticacaoRoutes };
